// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YoutubeThumbnailDownloaderRouteImport } from './routes/youtube-thumbnail-downloader'
import { Route as WordUnscramblerRouteImport } from './routes/word-unscrambler'
import { Route as WordFrequencyRouteImport } from './routes/word-frequency'
import { Route as WordCounterRouteImport } from './routes/word-counter'
import { Route as WhitespaceCleanerRouteImport } from './routes/whitespace-cleaner'
import { Route as WaterIntakeCalculatorRouteImport } from './routes/water-intake-calculator'
import { Route as ViolinPlotRouteImport } from './routes/violin-plot'
import { Route as VennDiagramRouteImport } from './routes/venn-diagram'
import { Route as UuidInspectorRouteImport } from './routes/uuid-inspector'
import { Route as UrlEncodeRouteImport } from './routes/url-encode'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as UnitConverterRouteImport } from './routes/unit-converter'
import { Route as TypingSpeedTestRouteImport } from './routes/typing-speed-test'
import { Route as TmCalculatorRouteImport } from './routes/tm-calculator'
import { Route as TimerRouteImport } from './routes/timer'
import { Route as TextToBinaryRouteImport } from './routes/text-to-binary'
import { Route as TextReverseRouteImport } from './routes/text-reverse'
import { Route as TextRepeatRouteImport } from './routes/text-repeat'
import { Route as TextDiffRouteImport } from './routes/text-diff'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SyllableCounterRouteImport } from './routes/syllable-counter'
import { Route as StatisticsCalculatorRouteImport } from './routes/statistics-calculator'
import { Route as SolutionDilutionRouteImport } from './routes/solution-dilution'
import { Route as SlugGeneratorRouteImport } from './routes/slug-generator'
import { Route as SipCalculatorRouteImport } from './routes/sip-calculator'
import { Route as SignatureMakerRouteImport } from './routes/signature-maker'
import { Route as ScatterPlotRouteImport } from './routes/scatter-plot'
import { Route as RulerRouteImport } from './routes/ruler'
import { Route as RscuRouteImport } from './routes/rscu'
import { Route as RomanNumeralRouteImport } from './routes/roman-numeral'
import { Route as RidgelinePlotRouteImport } from './routes/ridgeline-plot'
import { Route as ReverseComplementRouteImport } from './routes/reverse-complement'
import { Route as RemoveDuplicateLinesRouteImport } from './routes/remove-duplicate-lines'
import { Route as ReadabilityCheckerRouteImport } from './routes/readability-checker'
import { Route as RandomGeneratorRouteImport } from './routes/random-generator'
import { Route as RadarChartRouteImport } from './routes/radar-chart'
import { Route as QrCodeGeneratorRouteImport } from './routes/qr-code-generator'
import { Route as ProteinTranslationRouteImport } from './routes/protein-translation'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PpiCalculatorRouteImport } from './routes/ppi-calculator'
import { Route as PieChartRouteImport } from './routes/pie-chart'
import { Route as PhredQualityScoreRouteImport } from './routes/phred-quality-score'
import { Route as PercentageCalculatorRouteImport } from './routes/percentage-calculator'
import { Route as PercentSolutionRouteImport } from './routes/percent-solution'
import { Route as PcrMasterMixCalculatorRouteImport } from './routes/pcr-master-mix-calculator'
import { Route as PasswordGeneratorRouteImport } from './routes/password-generator'
import { Route as Od260ConcentrationRouteImport } from './routes/od260-concentration'
import { Route as NumberToWordsRouteImport } from './routes/number-to-words'
import { Route as NumberBaseRouteImport } from './routes/number-base'
import { Route as NormalityRouteImport } from './routes/normality'
import { Route as MorseCodeRouteImport } from './routes/morse-code'
import { Route as MolecularWeightRouteImport } from './routes/molecular-weight'
import { Route as MassMolarityRouteImport } from './routes/mass-molarity'
import { Route as MarkdownTableGeneratorRouteImport } from './routes/markdown-table-generator'
import { Route as MacroCalculatorRouteImport } from './routes/macro-calculator'
import { Route as LoremIpsumRouteImport } from './routes/lorem-ipsum'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoanCalculatorRouteImport } from './routes/loan-calculator'
import { Route as LineSorterRouteImport } from './routes/line-sorter'
import { Route as LineChartRouteImport } from './routes/line-chart'
import { Route as JwtDecoderRouteImport } from './routes/jwt-decoder'
import { Route as JsonFormatterRouteImport } from './routes/json-formatter'
import { Route as IupacToRegexRouteImport } from './routes/iupac-to-regex'
import { Route as IdealWeightCalculatorRouteImport } from './routes/ideal-weight-calculator'
import { Route as HplcMethodTransferRouteImport } from './routes/hplc-method-transfer'
import { Route as HistogramRouteImport } from './routes/histogram'
import { Route as HeatmapRouteImport } from './routes/heatmap'
import { Route as HashGeneratorRouteImport } from './routes/hash-generator'
import { Route as GpaCalculatorRouteImport } from './routes/gpa-calculator'
import { Route as GcSkewRouteImport } from './routes/gc-skew'
import { Route as GcContentRouteImport } from './routes/gc-content'
import { Route as GForceCalculatorRouteImport } from './routes/g-force-calculator'
import { Route as FractionCalculatorRouteImport } from './routes/fraction-calculator'
import { Route as FindReplaceRouteImport } from './routes/find-replace'
import { Route as F1FantasyRouteImport } from './routes/f1-fantasy'
import { Route as DonutChartRouteImport } from './routes/donut-chart'
import { Route as DnaRnaMolecularWeightRouteImport } from './routes/dna-rna-molecular-weight'
import { Route as DiceRollerRouteImport } from './routes/dice-roller'
import { Route as DecisionWheelRouteImport } from './routes/decision-wheel'
import { Route as DateDifferenceRouteImport } from './routes/date-difference'
import { Route as DataSizeRouteImport } from './routes/data-size'
import { Route as CsvToJsonRouteImport } from './routes/csv-to-json'
import { Route as CronExpressionExplainerRouteImport } from './routes/cron-expression-explainer'
import { Route as CountdownTimerRouteImport } from './routes/countdown-timer'
import { Route as ContrastCheckerRouteImport } from './routes/contrast-checker'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompoundInterestRouteImport } from './routes/compound-interest'
import { Route as ColorPaletteRouteImport } from './routes/color-palette'
import { Route as ColorConverterRouteImport } from './routes/color-converter'
import { Route as CodonUsageRouteImport } from './routes/codon-usage'
import { Route as CharInspectorRouteImport } from './routes/char-inspector'
import { Route as CaseConverterRouteImport } from './routes/case-converter'
import { Route as BufferRecipeCalculatorRouteImport } from './routes/buffer-recipe-calculator'
import { Route as BubbleChartRouteImport } from './routes/bubble-chart'
import { Route as BoxPlotRouteImport } from './routes/box-plot'
import { Route as BoilingPointCalculatorRouteImport } from './routes/boiling-point-calculator'
import { Route as BodyFatCalculatorRouteImport } from './routes/body-fat-calculator'
import { Route as BmrCalculatorRouteImport } from './routes/bmr-calculator'
import { Route as BmiCalculatorRouteImport } from './routes/bmi-calculator'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as Base64RouteImport } from './routes/base64'
import { Route as BarChartRouteImport } from './routes/bar-chart'
import { Route as AspectRatioRouteImport } from './routes/aspect-ratio'
import { Route as AreaChartRouteImport } from './routes/area-chart'
import { Route as AgeCalculatorRouteImport } from './routes/age-calculator'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as YoutubeThumbnailDownloaderIndexRouteImport } from './routes/youtube-thumbnail-downloader/index'
import { Route as YoutubeThumbnailDownloaderVariantRouteImport } from './routes/youtube-thumbnail-downloader/$variant'
import { Route as WordUnscramblerIndexRouteImport } from './routes/word-unscrambler/index'
import { Route as WordUnscramblerLettersRouteImport } from './routes/word-unscrambler/$letters'
import { Route as UnitConverterIndexRouteImport } from './routes/unit-converter/index'
import { Route as UnitConverterCategoryRouteImport } from './routes/unit-converter/$category'
import { Route as TypingSpeedTestIndexRouteImport } from './routes/typing-speed-test/index'
import { Route as TypingSpeedTestVariantRouteImport } from './routes/typing-speed-test/$variant'
import { Route as TimerIndexRouteImport } from './routes/timer/index'
import { Route as TimerStopwatchRouteImport } from './routes/timer/stopwatch'
import { Route as TimerPresetRouteImport } from './routes/timer/$preset'
import { Route as SyllableCounterIndexRouteImport } from './routes/syllable-counter/index'
import { Route as SyllableCounterHaikuRouteImport } from './routes/syllable-counter/haiku'
import { Route as SipCalculatorIndexRouteImport } from './routes/sip-calculator/index'
import { Route as SipCalculatorCalcRouteImport } from './routes/sip-calculator/$calc'
import { Route as SignatureMakerIndexRouteImport } from './routes/signature-maker/index'
import { Route as SignatureMakerTypeRouteImport } from './routes/signature-maker/type'
import { Route as PercentageCalculatorIndexRouteImport } from './routes/percentage-calculator/index'
import { Route as PercentageCalculatorCalcRouteImport } from './routes/percentage-calculator/$calc'
import { Route as F1FantasyIndexRouteImport } from './routes/f1-fantasy/index'
import { Route as F1FantasyStatisticsRouteImport } from './routes/f1-fantasy/statistics'
import { Route as F1FantasyStandingsRouteImport } from './routes/f1-fantasy/standings'
import { Route as F1FantasyFantasyPointsRouteImport } from './routes/f1-fantasy/fantasy-points'
import { Route as F1FantasyBudgetBoostRouteImport } from './routes/f1-fantasy/budget-boost'
import { Route as F1FantasyApexTeamRouteImport } from './routes/f1-fantasy/apex-team'
import { Route as BmiCalculatorIndexRouteImport } from './routes/bmi-calculator/index'
import { Route as BmiCalculatorCalcRouteImport } from './routes/bmi-calculator/$calc'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as AuthenticatedProtectedRouteImport } from './routes/_authenticated/protected'
import { Route as F1FantasyStatisticsIndexRouteImport } from './routes/f1-fantasy/statistics/index'
import { Route as BlogToolIndexRouteImport } from './routes/blog/$tool/index'
import { Route as BlogTagsTagRouteImport } from './routes/blog/tags/$tag'
import { Route as AuthenticatedAdminContactRouteImport } from './routes/_authenticated/admin.contact'
import { Route as F1FantasyStatisticsDriversSlugRouteImport } from './routes/f1-fantasy/statistics/drivers.$slug'
import { Route as F1FantasyStatisticsConstructorsSlugRouteImport } from './routes/f1-fantasy/statistics/constructors.$slug'
import { Route as BlogToolTopicIndexRouteImport } from './routes/blog/$tool/$topic/index'
import { Route as BlogToolTopicSlugRouteImport } from './routes/blog/$tool/$topic/$slug'

const YoutubeThumbnailDownloaderRoute = YoutubeThumbnailDownloaderRouteImport.update({
            id: '/youtube-thumbnail-downloader',path: '/youtube-thumbnail-downloader',getParentRoute: () => rootRouteImport
          })
const WordUnscramblerRoute = WordUnscramblerRouteImport.update({
            id: '/word-unscrambler',path: '/word-unscrambler',getParentRoute: () => rootRouteImport
          })
const WordFrequencyRoute = WordFrequencyRouteImport.update({
            id: '/word-frequency',path: '/word-frequency',getParentRoute: () => rootRouteImport
          })
const WordCounterRoute = WordCounterRouteImport.update({
            id: '/word-counter',path: '/word-counter',getParentRoute: () => rootRouteImport
          })
const WhitespaceCleanerRoute = WhitespaceCleanerRouteImport.update({
            id: '/whitespace-cleaner',path: '/whitespace-cleaner',getParentRoute: () => rootRouteImport
          })
const WaterIntakeCalculatorRoute = WaterIntakeCalculatorRouteImport.update({
            id: '/water-intake-calculator',path: '/water-intake-calculator',getParentRoute: () => rootRouteImport
          })
const ViolinPlotRoute = ViolinPlotRouteImport.update({
            id: '/violin-plot',path: '/violin-plot',getParentRoute: () => rootRouteImport
          })
const VennDiagramRoute = VennDiagramRouteImport.update({
            id: '/venn-diagram',path: '/venn-diagram',getParentRoute: () => rootRouteImport
          })
const UuidInspectorRoute = UuidInspectorRouteImport.update({
            id: '/uuid-inspector',path: '/uuid-inspector',getParentRoute: () => rootRouteImport
          })
const UrlEncodeRoute = UrlEncodeRouteImport.update({
            id: '/url-encode',path: '/url-encode',getParentRoute: () => rootRouteImport
          })
const UpgradeRoute = UpgradeRouteImport.update({
            id: '/upgrade',path: '/upgrade',getParentRoute: () => rootRouteImport
          })
const UnitConverterRoute = UnitConverterRouteImport.update({
            id: '/unit-converter',path: '/unit-converter',getParentRoute: () => rootRouteImport
          })
const TypingSpeedTestRoute = TypingSpeedTestRouteImport.update({
            id: '/typing-speed-test',path: '/typing-speed-test',getParentRoute: () => rootRouteImport
          })
const TmCalculatorRoute = TmCalculatorRouteImport.update({
            id: '/tm-calculator',path: '/tm-calculator',getParentRoute: () => rootRouteImport
          })
const TimerRoute = TimerRouteImport.update({
            id: '/timer',path: '/timer',getParentRoute: () => rootRouteImport
          })
const TextToBinaryRoute = TextToBinaryRouteImport.update({
            id: '/text-to-binary',path: '/text-to-binary',getParentRoute: () => rootRouteImport
          })
const TextReverseRoute = TextReverseRouteImport.update({
            id: '/text-reverse',path: '/text-reverse',getParentRoute: () => rootRouteImport
          })
const TextRepeatRoute = TextRepeatRouteImport.update({
            id: '/text-repeat',path: '/text-repeat',getParentRoute: () => rootRouteImport
          })
const TextDiffRoute = TextDiffRouteImport.update({
            id: '/text-diff',path: '/text-diff',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SyllableCounterRoute = SyllableCounterRouteImport.update({
            id: '/syllable-counter',path: '/syllable-counter',getParentRoute: () => rootRouteImport
          })
const StatisticsCalculatorRoute = StatisticsCalculatorRouteImport.update({
            id: '/statistics-calculator',path: '/statistics-calculator',getParentRoute: () => rootRouteImport
          })
const SolutionDilutionRoute = SolutionDilutionRouteImport.update({
            id: '/solution-dilution',path: '/solution-dilution',getParentRoute: () => rootRouteImport
          })
const SlugGeneratorRoute = SlugGeneratorRouteImport.update({
            id: '/slug-generator',path: '/slug-generator',getParentRoute: () => rootRouteImport
          })
const SipCalculatorRoute = SipCalculatorRouteImport.update({
            id: '/sip-calculator',path: '/sip-calculator',getParentRoute: () => rootRouteImport
          })
const SignatureMakerRoute = SignatureMakerRouteImport.update({
            id: '/signature-maker',path: '/signature-maker',getParentRoute: () => rootRouteImport
          })
const ScatterPlotRoute = ScatterPlotRouteImport.update({
            id: '/scatter-plot',path: '/scatter-plot',getParentRoute: () => rootRouteImport
          })
const RulerRoute = RulerRouteImport.update({
            id: '/ruler',path: '/ruler',getParentRoute: () => rootRouteImport
          })
const RscuRoute = RscuRouteImport.update({
            id: '/rscu',path: '/rscu',getParentRoute: () => rootRouteImport
          })
const RomanNumeralRoute = RomanNumeralRouteImport.update({
            id: '/roman-numeral',path: '/roman-numeral',getParentRoute: () => rootRouteImport
          })
const RidgelinePlotRoute = RidgelinePlotRouteImport.update({
            id: '/ridgeline-plot',path: '/ridgeline-plot',getParentRoute: () => rootRouteImport
          })
const ReverseComplementRoute = ReverseComplementRouteImport.update({
            id: '/reverse-complement',path: '/reverse-complement',getParentRoute: () => rootRouteImport
          })
const RemoveDuplicateLinesRoute = RemoveDuplicateLinesRouteImport.update({
            id: '/remove-duplicate-lines',path: '/remove-duplicate-lines',getParentRoute: () => rootRouteImport
          })
const ReadabilityCheckerRoute = ReadabilityCheckerRouteImport.update({
            id: '/readability-checker',path: '/readability-checker',getParentRoute: () => rootRouteImport
          })
const RandomGeneratorRoute = RandomGeneratorRouteImport.update({
            id: '/random-generator',path: '/random-generator',getParentRoute: () => rootRouteImport
          })
const RadarChartRoute = RadarChartRouteImport.update({
            id: '/radar-chart',path: '/radar-chart',getParentRoute: () => rootRouteImport
          })
const QrCodeGeneratorRoute = QrCodeGeneratorRouteImport.update({
            id: '/qr-code-generator',path: '/qr-code-generator',getParentRoute: () => rootRouteImport
          })
const ProteinTranslationRoute = ProteinTranslationRouteImport.update({
            id: '/protein-translation',path: '/protein-translation',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PpiCalculatorRoute = PpiCalculatorRouteImport.update({
            id: '/ppi-calculator',path: '/ppi-calculator',getParentRoute: () => rootRouteImport
          })
const PieChartRoute = PieChartRouteImport.update({
            id: '/pie-chart',path: '/pie-chart',getParentRoute: () => rootRouteImport
          })
const PhredQualityScoreRoute = PhredQualityScoreRouteImport.update({
            id: '/phred-quality-score',path: '/phred-quality-score',getParentRoute: () => rootRouteImport
          })
const PercentageCalculatorRoute = PercentageCalculatorRouteImport.update({
            id: '/percentage-calculator',path: '/percentage-calculator',getParentRoute: () => rootRouteImport
          })
const PercentSolutionRoute = PercentSolutionRouteImport.update({
            id: '/percent-solution',path: '/percent-solution',getParentRoute: () => rootRouteImport
          })
const PcrMasterMixCalculatorRoute = PcrMasterMixCalculatorRouteImport.update({
            id: '/pcr-master-mix-calculator',path: '/pcr-master-mix-calculator',getParentRoute: () => rootRouteImport
          })
const PasswordGeneratorRoute = PasswordGeneratorRouteImport.update({
            id: '/password-generator',path: '/password-generator',getParentRoute: () => rootRouteImport
          })
const Od260ConcentrationRoute = Od260ConcentrationRouteImport.update({
            id: '/od260-concentration',path: '/od260-concentration',getParentRoute: () => rootRouteImport
          })
const NumberToWordsRoute = NumberToWordsRouteImport.update({
            id: '/number-to-words',path: '/number-to-words',getParentRoute: () => rootRouteImport
          })
const NumberBaseRoute = NumberBaseRouteImport.update({
            id: '/number-base',path: '/number-base',getParentRoute: () => rootRouteImport
          })
const NormalityRoute = NormalityRouteImport.update({
            id: '/normality',path: '/normality',getParentRoute: () => rootRouteImport
          })
const MorseCodeRoute = MorseCodeRouteImport.update({
            id: '/morse-code',path: '/morse-code',getParentRoute: () => rootRouteImport
          })
const MolecularWeightRoute = MolecularWeightRouteImport.update({
            id: '/molecular-weight',path: '/molecular-weight',getParentRoute: () => rootRouteImport
          })
const MassMolarityRoute = MassMolarityRouteImport.update({
            id: '/mass-molarity',path: '/mass-molarity',getParentRoute: () => rootRouteImport
          })
const MarkdownTableGeneratorRoute = MarkdownTableGeneratorRouteImport.update({
            id: '/markdown-table-generator',path: '/markdown-table-generator',getParentRoute: () => rootRouteImport
          })
const MacroCalculatorRoute = MacroCalculatorRouteImport.update({
            id: '/macro-calculator',path: '/macro-calculator',getParentRoute: () => rootRouteImport
          })
const LoremIpsumRoute = LoremIpsumRouteImport.update({
            id: '/lorem-ipsum',path: '/lorem-ipsum',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LoanCalculatorRoute = LoanCalculatorRouteImport.update({
            id: '/loan-calculator',path: '/loan-calculator',getParentRoute: () => rootRouteImport
          })
const LineSorterRoute = LineSorterRouteImport.update({
            id: '/line-sorter',path: '/line-sorter',getParentRoute: () => rootRouteImport
          })
const LineChartRoute = LineChartRouteImport.update({
            id: '/line-chart',path: '/line-chart',getParentRoute: () => rootRouteImport
          })
const JwtDecoderRoute = JwtDecoderRouteImport.update({
            id: '/jwt-decoder',path: '/jwt-decoder',getParentRoute: () => rootRouteImport
          })
const JsonFormatterRoute = JsonFormatterRouteImport.update({
            id: '/json-formatter',path: '/json-formatter',getParentRoute: () => rootRouteImport
          })
const IupacToRegexRoute = IupacToRegexRouteImport.update({
            id: '/iupac-to-regex',path: '/iupac-to-regex',getParentRoute: () => rootRouteImport
          })
const IdealWeightCalculatorRoute = IdealWeightCalculatorRouteImport.update({
            id: '/ideal-weight-calculator',path: '/ideal-weight-calculator',getParentRoute: () => rootRouteImport
          })
const HplcMethodTransferRoute = HplcMethodTransferRouteImport.update({
            id: '/hplc-method-transfer',path: '/hplc-method-transfer',getParentRoute: () => rootRouteImport
          })
const HistogramRoute = HistogramRouteImport.update({
            id: '/histogram',path: '/histogram',getParentRoute: () => rootRouteImport
          })
const HeatmapRoute = HeatmapRouteImport.update({
            id: '/heatmap',path: '/heatmap',getParentRoute: () => rootRouteImport
          })
const HashGeneratorRoute = HashGeneratorRouteImport.update({
            id: '/hash-generator',path: '/hash-generator',getParentRoute: () => rootRouteImport
          })
const GpaCalculatorRoute = GpaCalculatorRouteImport.update({
            id: '/gpa-calculator',path: '/gpa-calculator',getParentRoute: () => rootRouteImport
          })
const GcSkewRoute = GcSkewRouteImport.update({
            id: '/gc-skew',path: '/gc-skew',getParentRoute: () => rootRouteImport
          })
const GcContentRoute = GcContentRouteImport.update({
            id: '/gc-content',path: '/gc-content',getParentRoute: () => rootRouteImport
          })
const GForceCalculatorRoute = GForceCalculatorRouteImport.update({
            id: '/g-force-calculator',path: '/g-force-calculator',getParentRoute: () => rootRouteImport
          })
const FractionCalculatorRoute = FractionCalculatorRouteImport.update({
            id: '/fraction-calculator',path: '/fraction-calculator',getParentRoute: () => rootRouteImport
          })
const FindReplaceRoute = FindReplaceRouteImport.update({
            id: '/find-replace',path: '/find-replace',getParentRoute: () => rootRouteImport
          })
const F1FantasyRoute = F1FantasyRouteImport.update({
            id: '/f1-fantasy',path: '/f1-fantasy',getParentRoute: () => rootRouteImport
          })
const DonutChartRoute = DonutChartRouteImport.update({
            id: '/donut-chart',path: '/donut-chart',getParentRoute: () => rootRouteImport
          })
const DnaRnaMolecularWeightRoute = DnaRnaMolecularWeightRouteImport.update({
            id: '/dna-rna-molecular-weight',path: '/dna-rna-molecular-weight',getParentRoute: () => rootRouteImport
          })
const DiceRollerRoute = DiceRollerRouteImport.update({
            id: '/dice-roller',path: '/dice-roller',getParentRoute: () => rootRouteImport
          })
const DecisionWheelRoute = DecisionWheelRouteImport.update({
            id: '/decision-wheel',path: '/decision-wheel',getParentRoute: () => rootRouteImport
          })
const DateDifferenceRoute = DateDifferenceRouteImport.update({
            id: '/date-difference',path: '/date-difference',getParentRoute: () => rootRouteImport
          })
const DataSizeRoute = DataSizeRouteImport.update({
            id: '/data-size',path: '/data-size',getParentRoute: () => rootRouteImport
          })
const CsvToJsonRoute = CsvToJsonRouteImport.update({
            id: '/csv-to-json',path: '/csv-to-json',getParentRoute: () => rootRouteImport
          })
const CronExpressionExplainerRoute = CronExpressionExplainerRouteImport.update({
            id: '/cron-expression-explainer',path: '/cron-expression-explainer',getParentRoute: () => rootRouteImport
          })
const CountdownTimerRoute = CountdownTimerRouteImport.update({
            id: '/countdown-timer',path: '/countdown-timer',getParentRoute: () => rootRouteImport
          })
const ContrastCheckerRoute = ContrastCheckerRouteImport.update({
            id: '/contrast-checker',path: '/contrast-checker',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CompoundInterestRoute = CompoundInterestRouteImport.update({
            id: '/compound-interest',path: '/compound-interest',getParentRoute: () => rootRouteImport
          })
const ColorPaletteRoute = ColorPaletteRouteImport.update({
            id: '/color-palette',path: '/color-palette',getParentRoute: () => rootRouteImport
          })
const ColorConverterRoute = ColorConverterRouteImport.update({
            id: '/color-converter',path: '/color-converter',getParentRoute: () => rootRouteImport
          })
const CodonUsageRoute = CodonUsageRouteImport.update({
            id: '/codon-usage',path: '/codon-usage',getParentRoute: () => rootRouteImport
          })
const CharInspectorRoute = CharInspectorRouteImport.update({
            id: '/char-inspector',path: '/char-inspector',getParentRoute: () => rootRouteImport
          })
const CaseConverterRoute = CaseConverterRouteImport.update({
            id: '/case-converter',path: '/case-converter',getParentRoute: () => rootRouteImport
          })
const BufferRecipeCalculatorRoute = BufferRecipeCalculatorRouteImport.update({
            id: '/buffer-recipe-calculator',path: '/buffer-recipe-calculator',getParentRoute: () => rootRouteImport
          })
const BubbleChartRoute = BubbleChartRouteImport.update({
            id: '/bubble-chart',path: '/bubble-chart',getParentRoute: () => rootRouteImport
          })
const BoxPlotRoute = BoxPlotRouteImport.update({
            id: '/box-plot',path: '/box-plot',getParentRoute: () => rootRouteImport
          })
const BoilingPointCalculatorRoute = BoilingPointCalculatorRouteImport.update({
            id: '/boiling-point-calculator',path: '/boiling-point-calculator',getParentRoute: () => rootRouteImport
          })
const BodyFatCalculatorRoute = BodyFatCalculatorRouteImport.update({
            id: '/body-fat-calculator',path: '/body-fat-calculator',getParentRoute: () => rootRouteImport
          })
const BmrCalculatorRoute = BmrCalculatorRouteImport.update({
            id: '/bmr-calculator',path: '/bmr-calculator',getParentRoute: () => rootRouteImport
          })
const BmiCalculatorRoute = BmiCalculatorRouteImport.update({
            id: '/bmi-calculator',path: '/bmi-calculator',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const Base64Route = Base64RouteImport.update({
            id: '/base64',path: '/base64',getParentRoute: () => rootRouteImport
          })
const BarChartRoute = BarChartRouteImport.update({
            id: '/bar-chart',path: '/bar-chart',getParentRoute: () => rootRouteImport
          })
const AspectRatioRoute = AspectRatioRouteImport.update({
            id: '/aspect-ratio',path: '/aspect-ratio',getParentRoute: () => rootRouteImport
          })
const AreaChartRoute = AreaChartRouteImport.update({
            id: '/area-chart',path: '/area-chart',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorRoute = AgeCalculatorRouteImport.update({
            id: '/age-calculator',path: '/age-calculator',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const YoutubeThumbnailDownloaderIndexRoute = YoutubeThumbnailDownloaderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => YoutubeThumbnailDownloaderRoute
          })
const YoutubeThumbnailDownloaderVariantRoute = YoutubeThumbnailDownloaderVariantRouteImport.update({
            id: '/$variant',path: '/$variant',getParentRoute: () => YoutubeThumbnailDownloaderRoute
          })
const WordUnscramblerIndexRoute = WordUnscramblerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WordUnscramblerRoute
          })
const WordUnscramblerLettersRoute = WordUnscramblerLettersRouteImport.update({
            id: '/$letters',path: '/$letters',getParentRoute: () => WordUnscramblerRoute
          })
const UnitConverterIndexRoute = UnitConverterIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UnitConverterRoute
          })
const UnitConverterCategoryRoute = UnitConverterCategoryRouteImport.update({
            id: '/$category',path: '/$category',getParentRoute: () => UnitConverterRoute
          })
const TypingSpeedTestIndexRoute = TypingSpeedTestIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TypingSpeedTestRoute
          })
const TypingSpeedTestVariantRoute = TypingSpeedTestVariantRouteImport.update({
            id: '/$variant',path: '/$variant',getParentRoute: () => TypingSpeedTestRoute
          })
const TimerIndexRoute = TimerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TimerRoute
          })
const TimerStopwatchRoute = TimerStopwatchRouteImport.update({
            id: '/stopwatch',path: '/stopwatch',getParentRoute: () => TimerRoute
          })
const TimerPresetRoute = TimerPresetRouteImport.update({
            id: '/$preset',path: '/$preset',getParentRoute: () => TimerRoute
          })
const SyllableCounterIndexRoute = SyllableCounterIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SyllableCounterRoute
          })
const SyllableCounterHaikuRoute = SyllableCounterHaikuRouteImport.update({
            id: '/haiku',path: '/haiku',getParentRoute: () => SyllableCounterRoute
          })
const SipCalculatorIndexRoute = SipCalculatorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SipCalculatorRoute
          })
const SipCalculatorCalcRoute = SipCalculatorCalcRouteImport.update({
            id: '/$calc',path: '/$calc',getParentRoute: () => SipCalculatorRoute
          })
const SignatureMakerIndexRoute = SignatureMakerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SignatureMakerRoute
          })
const SignatureMakerTypeRoute = SignatureMakerTypeRouteImport.update({
            id: '/type',path: '/type',getParentRoute: () => SignatureMakerRoute
          })
const PercentageCalculatorIndexRoute = PercentageCalculatorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PercentageCalculatorRoute
          })
const PercentageCalculatorCalcRoute = PercentageCalculatorCalcRouteImport.update({
            id: '/$calc',path: '/$calc',getParentRoute: () => PercentageCalculatorRoute
          })
const F1FantasyIndexRoute = F1FantasyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => F1FantasyRoute
          })
const F1FantasyStatisticsRoute = F1FantasyStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => F1FantasyRoute
          })
const F1FantasyStandingsRoute = F1FantasyStandingsRouteImport.update({
            id: '/standings',path: '/standings',getParentRoute: () => F1FantasyRoute
          })
const F1FantasyFantasyPointsRoute = F1FantasyFantasyPointsRouteImport.update({
            id: '/fantasy-points',path: '/fantasy-points',getParentRoute: () => F1FantasyRoute
          })
const F1FantasyBudgetBoostRoute = F1FantasyBudgetBoostRouteImport.update({
            id: '/budget-boost',path: '/budget-boost',getParentRoute: () => F1FantasyRoute
          })
const F1FantasyApexTeamRoute = F1FantasyApexTeamRouteImport.update({
            id: '/apex-team',path: '/apex-team',getParentRoute: () => F1FantasyRoute
          })
const BmiCalculatorIndexRoute = BmiCalculatorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BmiCalculatorRoute
          })
const BmiCalculatorCalcRoute = BmiCalculatorCalcRouteImport.update({
            id: '/$calc',path: '/$calc',getParentRoute: () => BmiCalculatorRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const AuthenticatedProtectedRoute = AuthenticatedProtectedRouteImport.update({
            id: '/protected',path: '/protected',getParentRoute: () => AuthenticatedRoute
          })
const F1FantasyStatisticsIndexRoute = F1FantasyStatisticsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => F1FantasyStatisticsRoute
          })
const BlogToolIndexRoute = BlogToolIndexRouteImport.update({
            id: '/$tool/',path: '/$tool/',getParentRoute: () => BlogRoute
          })
const BlogTagsTagRoute = BlogTagsTagRouteImport.update({
            id: '/tags/$tag',path: '/tags/$tag',getParentRoute: () => BlogRoute
          })
const AuthenticatedAdminContactRoute = AuthenticatedAdminContactRouteImport.update({
            id: '/admin/contact',path: '/admin/contact',getParentRoute: () => AuthenticatedRoute
          })
const F1FantasyStatisticsDriversSlugRoute = F1FantasyStatisticsDriversSlugRouteImport.update({
            id: '/drivers/$slug',path: '/drivers/$slug',getParentRoute: () => F1FantasyStatisticsRoute
          })
const F1FantasyStatisticsConstructorsSlugRoute = F1FantasyStatisticsConstructorsSlugRouteImport.update({
            id: '/constructors/$slug',path: '/constructors/$slug',getParentRoute: () => F1FantasyStatisticsRoute
          })
const BlogToolTopicIndexRoute = BlogToolTopicIndexRouteImport.update({
            id: '/$tool/$topic/',path: '/$tool/$topic/',getParentRoute: () => BlogRoute
          })
const BlogToolTopicSlugRoute = BlogToolTopicSlugRouteImport.update({
            id: '/$tool/$topic/$slug',path: '/$tool/$topic/$slug',getParentRoute: () => BlogRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedProtectedRoute: AuthenticatedProtectedRoute,AuthenticatedAdminContactRoute: AuthenticatedAdminContactRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const BlogRouteChildren = {
  BlogIndexRoute: BlogIndexRoute,BlogTagsTagRoute: BlogTagsTagRoute,BlogToolIndexRoute: BlogToolIndexRoute,BlogToolTopicSlugRoute: BlogToolTopicSlugRoute,BlogToolTopicIndexRoute: BlogToolTopicIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const BmiCalculatorRouteChildren = {
  BmiCalculatorCalcRoute: BmiCalculatorCalcRoute,BmiCalculatorIndexRoute: BmiCalculatorIndexRoute
}

const BmiCalculatorRouteWithChildren = BmiCalculatorRoute._addFileChildren(BmiCalculatorRouteChildren)




const F1FantasyStatisticsRouteChildren = {
  F1FantasyStatisticsIndexRoute: F1FantasyStatisticsIndexRoute,F1FantasyStatisticsConstructorsSlugRoute: F1FantasyStatisticsConstructorsSlugRoute,F1FantasyStatisticsDriversSlugRoute: F1FantasyStatisticsDriversSlugRoute
}

const F1FantasyStatisticsRouteWithChildren = F1FantasyStatisticsRoute._addFileChildren(F1FantasyStatisticsRouteChildren)



const F1FantasyRouteChildren = {
  F1FantasyApexTeamRoute: F1FantasyApexTeamRoute,F1FantasyBudgetBoostRoute: F1FantasyBudgetBoostRoute,F1FantasyFantasyPointsRoute: F1FantasyFantasyPointsRoute,F1FantasyStandingsRoute: F1FantasyStandingsRoute,F1FantasyStatisticsRoute: F1FantasyStatisticsRouteWithChildren,F1FantasyIndexRoute: F1FantasyIndexRoute
}

const F1FantasyRouteWithChildren = F1FantasyRoute._addFileChildren(F1FantasyRouteChildren)




const PercentageCalculatorRouteChildren = {
  PercentageCalculatorCalcRoute: PercentageCalculatorCalcRoute,PercentageCalculatorIndexRoute: PercentageCalculatorIndexRoute
}

const PercentageCalculatorRouteWithChildren = PercentageCalculatorRoute._addFileChildren(PercentageCalculatorRouteChildren)




const SignatureMakerRouteChildren = {
  SignatureMakerTypeRoute: SignatureMakerTypeRoute,SignatureMakerIndexRoute: SignatureMakerIndexRoute
}

const SignatureMakerRouteWithChildren = SignatureMakerRoute._addFileChildren(SignatureMakerRouteChildren)




const SipCalculatorRouteChildren = {
  SipCalculatorCalcRoute: SipCalculatorCalcRoute,SipCalculatorIndexRoute: SipCalculatorIndexRoute
}

const SipCalculatorRouteWithChildren = SipCalculatorRoute._addFileChildren(SipCalculatorRouteChildren)




const SyllableCounterRouteChildren = {
  SyllableCounterHaikuRoute: SyllableCounterHaikuRoute,SyllableCounterIndexRoute: SyllableCounterIndexRoute
}

const SyllableCounterRouteWithChildren = SyllableCounterRoute._addFileChildren(SyllableCounterRouteChildren)




const TimerRouteChildren = {
  TimerPresetRoute: TimerPresetRoute,TimerStopwatchRoute: TimerStopwatchRoute,TimerIndexRoute: TimerIndexRoute
}

const TimerRouteWithChildren = TimerRoute._addFileChildren(TimerRouteChildren)




const TypingSpeedTestRouteChildren = {
  TypingSpeedTestVariantRoute: TypingSpeedTestVariantRoute,TypingSpeedTestIndexRoute: TypingSpeedTestIndexRoute
}

const TypingSpeedTestRouteWithChildren = TypingSpeedTestRoute._addFileChildren(TypingSpeedTestRouteChildren)




const UnitConverterRouteChildren = {
  UnitConverterCategoryRoute: UnitConverterCategoryRoute,UnitConverterIndexRoute: UnitConverterIndexRoute
}

const UnitConverterRouteWithChildren = UnitConverterRoute._addFileChildren(UnitConverterRouteChildren)




const WordUnscramblerRouteChildren = {
  WordUnscramblerLettersRoute: WordUnscramblerLettersRoute,WordUnscramblerIndexRoute: WordUnscramblerIndexRoute
}

const WordUnscramblerRouteWithChildren = WordUnscramblerRoute._addFileChildren(WordUnscramblerRouteChildren)




const YoutubeThumbnailDownloaderRouteChildren = {
  YoutubeThumbnailDownloaderVariantRoute: YoutubeThumbnailDownloaderVariantRoute,YoutubeThumbnailDownloaderIndexRoute: YoutubeThumbnailDownloaderIndexRoute
}

const YoutubeThumbnailDownloaderRouteWithChildren = YoutubeThumbnailDownloaderRoute._addFileChildren(YoutubeThumbnailDownloaderRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,AgeCalculatorRoute: AgeCalculatorRoute,AreaChartRoute: AreaChartRoute,AspectRatioRoute: AspectRatioRoute,BarChartRoute: BarChartRoute,Base64Route: Base64Route,BlogRoute: BlogRouteWithChildren,BmiCalculatorRoute: BmiCalculatorRouteWithChildren,BmrCalculatorRoute: BmrCalculatorRoute,BodyFatCalculatorRoute: BodyFatCalculatorRoute,BoilingPointCalculatorRoute: BoilingPointCalculatorRoute,BoxPlotRoute: BoxPlotRoute,BubbleChartRoute: BubbleChartRoute,BufferRecipeCalculatorRoute: BufferRecipeCalculatorRoute,CaseConverterRoute: CaseConverterRoute,CharInspectorRoute: CharInspectorRoute,CodonUsageRoute: CodonUsageRoute,ColorConverterRoute: ColorConverterRoute,ColorPaletteRoute: ColorPaletteRoute,CompoundInterestRoute: CompoundInterestRoute,ContactRoute: ContactRoute,ContrastCheckerRoute: ContrastCheckerRoute,CountdownTimerRoute: CountdownTimerRoute,CronExpressionExplainerRoute: CronExpressionExplainerRoute,CsvToJsonRoute: CsvToJsonRoute,DataSizeRoute: DataSizeRoute,DateDifferenceRoute: DateDifferenceRoute,DecisionWheelRoute: DecisionWheelRoute,DiceRollerRoute: DiceRollerRoute,DnaRnaMolecularWeightRoute: DnaRnaMolecularWeightRoute,DonutChartRoute: DonutChartRoute,F1FantasyRoute: F1FantasyRouteWithChildren,FindReplaceRoute: FindReplaceRoute,FractionCalculatorRoute: FractionCalculatorRoute,GForceCalculatorRoute: GForceCalculatorRoute,GcContentRoute: GcContentRoute,GcSkewRoute: GcSkewRoute,GpaCalculatorRoute: GpaCalculatorRoute,HashGeneratorRoute: HashGeneratorRoute,HeatmapRoute: HeatmapRoute,HistogramRoute: HistogramRoute,HplcMethodTransferRoute: HplcMethodTransferRoute,IdealWeightCalculatorRoute: IdealWeightCalculatorRoute,IupacToRegexRoute: IupacToRegexRoute,JsonFormatterRoute: JsonFormatterRoute,JwtDecoderRoute: JwtDecoderRoute,LineChartRoute: LineChartRoute,LineSorterRoute: LineSorterRoute,LoanCalculatorRoute: LoanCalculatorRoute,LoginRoute: LoginRoute,LoremIpsumRoute: LoremIpsumRoute,MacroCalculatorRoute: MacroCalculatorRoute,MarkdownTableGeneratorRoute: MarkdownTableGeneratorRoute,MassMolarityRoute: MassMolarityRoute,MolecularWeightRoute: MolecularWeightRoute,MorseCodeRoute: MorseCodeRoute,NormalityRoute: NormalityRoute,NumberBaseRoute: NumberBaseRoute,NumberToWordsRoute: NumberToWordsRoute,Od260ConcentrationRoute: Od260ConcentrationRoute,PasswordGeneratorRoute: PasswordGeneratorRoute,PcrMasterMixCalculatorRoute: PcrMasterMixCalculatorRoute,PercentSolutionRoute: PercentSolutionRoute,PercentageCalculatorRoute: PercentageCalculatorRouteWithChildren,PhredQualityScoreRoute: PhredQualityScoreRoute,PieChartRoute: PieChartRoute,PpiCalculatorRoute: PpiCalculatorRoute,PrivacyRoute: PrivacyRoute,ProteinTranslationRoute: ProteinTranslationRoute,QrCodeGeneratorRoute: QrCodeGeneratorRoute,RadarChartRoute: RadarChartRoute,RandomGeneratorRoute: RandomGeneratorRoute,ReadabilityCheckerRoute: ReadabilityCheckerRoute,RemoveDuplicateLinesRoute: RemoveDuplicateLinesRoute,ReverseComplementRoute: ReverseComplementRoute,RidgelinePlotRoute: RidgelinePlotRoute,RomanNumeralRoute: RomanNumeralRoute,RscuRoute: RscuRoute,RulerRoute: RulerRoute,ScatterPlotRoute: ScatterPlotRoute,SignatureMakerRoute: SignatureMakerRouteWithChildren,SipCalculatorRoute: SipCalculatorRouteWithChildren,SlugGeneratorRoute: SlugGeneratorRoute,SolutionDilutionRoute: SolutionDilutionRoute,StatisticsCalculatorRoute: StatisticsCalculatorRoute,SyllableCounterRoute: SyllableCounterRouteWithChildren,TermsRoute: TermsRoute,TextDiffRoute: TextDiffRoute,TextRepeatRoute: TextRepeatRoute,TextReverseRoute: TextReverseRoute,TextToBinaryRoute: TextToBinaryRoute,TimerRoute: TimerRouteWithChildren,TmCalculatorRoute: TmCalculatorRoute,TypingSpeedTestRoute: TypingSpeedTestRouteWithChildren,UnitConverterRoute: UnitConverterRouteWithChildren,UpgradeRoute: UpgradeRoute,UrlEncodeRoute: UrlEncodeRoute,UuidInspectorRoute: UuidInspectorRoute,VennDiagramRoute: VennDiagramRoute,ViolinPlotRoute: ViolinPlotRoute,WaterIntakeCalculatorRoute: WaterIntakeCalculatorRoute,WhitespaceCleanerRoute: WhitespaceCleanerRoute,WordCounterRoute: WordCounterRoute,WordFrequencyRoute: WordFrequencyRoute,WordUnscramblerRoute: WordUnscramblerRouteWithChildren,YoutubeThumbnailDownloaderRoute: YoutubeThumbnailDownloaderRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)